@if (isAtlasEnabled$ | async) {
  @if (atlasData$ | async; as atlasData) {
    <bc-business-navbar
      [serviceProviderId]="customerVoiceId$ | async"
      [partnerId]="atlasData.partnerID"
      [marketId]="atlasData.marketID"
      [accountId]="atlasData.accountGroupID"
      entitlementId="partner-access"
    ></bc-business-navbar>
  }
}
<router-outlet></router-outlet>
